<template>
  <v-card>
    <v-card-title class="align-start">
      <span>Recipient Status</span>

      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text>
     
     
      <div id="chart"></div>

      
    </v-card-text>
  </v-card>
</template>

<script>

import { mdiDotsVertical, mdiTrendingUp, mdiCurrencyUsd } from '@mdi/js'
import { getCurrentInstance } from '@vue/composition-api'
import daskboardserice from '@/service/Dashboard.service'
import moment from 'moment'
export default {

  setup() {
    const ins = getCurrentInstance()?.proxy
    const $vuetify = ins && ins.$vuetify ? ins.$vuetify : null
    const customChartColor = $vuetify.theme.isDark ? '#3b3559' : '#f5f5f5'

    return {

      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiCurrencyUsd,
      },
    }
  },
   
   
   watch: {
    options: {
      handler() {
        this.chartMap()
      },
      deep: true,
    },
  },
  mounted() {
    this.chartMap()

  },
  methods:{

    async chartMap(){
      const service = new daskboardserice()
      let response = await service.getDaskboard()
      var data11 = response.Recipient_Status
      var data1 = data11.Recipient_Received
      var data2 = data11.Tissue_Distributed
      const sectorCall = data1.map((d) => (d["count"]))
      const days = data1.map((d) => (d["week_name"]))
      const secondCall = data2.map((d)=>(d["count"]))
      // console.log("data type", data11)
      // const sectorCall = data11.map((d) => (d["count"]))
      // const days = data11.map((d) => (d["week_name"]))

      var options = {
          series: [{
          name: 'Recipient Received',
          data: sectorCall
        }, {
          name: 'Tissue Distributed',
          data: secondCall
        },],
          chart: {
          type: 'bar',
          height: 350
        },
        colors:['#1bbc9b','rgb(0, 143, 251)'],
        plotOptions: {
          bar: {
          columnWidth: '55%',
          borderRadius: 5,
          startingShape: 'rounded',
          endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2,
          
        },
        xaxis: {
          categories: days,
        },
        yaxis: {
          // title: {
          //   text: '(thousands)'
          // }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  + val + " "
            }
          }
        }
        };
        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();
       
  
    }
  }
}
</script>
